/**
 * 重写覆盖系统本身window.open函数,避免污染太多现有代码逻辑
 */
import { localDataUser } from '@iebdc/utils/local-data';
import { crypto } from '@iebdc/utils/crypto';
// 保存原生window.open方法
export const originalWindowOpen = window.open;

// 白名单配置 - 可以根据实际需求修改
const domainWhitelist = [
  'yourdomain.com',
  'trusted-site.com',
  'localhost'
];

// 重写window.open方法
window.open = function (url, target, features, isDownLoad) {
  console.log(`[Window Open] 尝试打开: ${url}, 目标: ${target}`);
  var token = '';
  if (localDataUser.get()) {
    token = localDataUser.get().token;
  }
  if (!url.startsWith(window.CONFIG.internet)) {
    url = window.CONFIG.internet + 'proxy/file?url=' + encodeURIComponent(crypto.encryptByAES(url)) + '&token=' + (token) + (isDownLoad ? ('&attachment=' + isDownLoad) : '');
  }
  const newWindow = originalWindowOpen(url, (isDownLoad ? '_self' : (target || '_blank')), features);


  return newWindow;
};
export default window.open;